import api from '../api'

import {
  fetchBaterPontoStart,
  fetchBaterPontoSuccess,
  fetchBaterPontoFail,
} from '../reducers/endpoints/baterPonto'
import {take, put, call} from 'redux-saga/effects'

export function* fetchBaterPonto(mss) {
  const url = `/ponto/baterponto`

  //const userToken = localStorage.getItem('token')
  const values = mss.mss
  const post = 
    {
        "Ponto": {
            "RE": values.Ponto.RE,
            "Empresa": values.Ponto.Empresa,
            "Cliente": values.Ponto.Cliente,
            "Unidade": values.Ponto.Unidade,
            "HorarioEntrada": values.Ponto.HorarioEntrada,
            "HorarioSaida": values.Ponto.HorarioSaida,
            "TipoPonto": values.Ponto.TipoPonto
        },
        "Login": {
            "Login": values.Login.Login,
            "Password": values.Login.Password,
            "Empresa": values.Login.Empresa
        }
    }
  
  const headerParams = {
    headers: {
    //    Authorization: `Bearer ${ mss.mss.token }`
    }
  }

  console.log('fetchBaterPonto', post, JSON.stringify(post))

  try {
    const {data: loginUser} = yield call([api, 'post'], url, post, headerParams)
    console.log('42 fetchBaterPonto', loginUser)
    yield put(fetchBaterPontoSuccess(loginUser))
  } catch (error) {
    console.log('42 fetchBaterPonto', error)

    yield put(fetchBaterPontoFail(error))
  }
}

export function* watchFetchBaterPonto() {
  while (true) {
    const {
      payload: mss
    } = yield take(fetchBaterPontoStart)
    yield call(fetchBaterPonto, mss)
  }
}